export default "__VITE_ASSET__qMks8fWE__"